import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    targetId: String, 
    caption: String,       
    width: String       
  }

  open(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const contentId = this.targetIdValue;
    const caption   = this.captionValue || "";
    const width     = this.widthValue || "80vw";

    if (!contentId) {
      console.warn("⚠️ Aucun ID de contenu défini pour fancybox-popup.");
      return;
    }

    //  Ferme toutes les instances fancybox déjà ouvertes
    if (window.Fancybox && typeof window.Fancybox.close === "function") {
      try { window.Fancybox.close(); } catch(_) {}
    }

    // Ouvre uniquement celle qu'on veut
    Fancybox.show([{
      src: `#${contentId}`,
      type: "inline",
      caption: caption,
      width: width,
      height: "auto"
    }]);
  }
}
